module.exports = __webpack_public_path__ + "static/img/a.0655b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/a.png
// module id = enZo
// module chunks = 12